import { useState } from "react"
import { Helmet } from "react-helmet-async"
import { CallLogsTable, TCallLogFilters } from "../../../../CallLogs"
import { useOutletContext } from "react-router"
import { ITripSource } from "../../../../TripSources"

export default function TripCallLogsPage() {
	const { tripSource } = useOutletContext<{
		tripSource: ITripSource
	}>()
	const [params, setParams] = useState<TCallLogFilters>({})
	return (
		<>
			<Helmet>
				<title>Call Logs | B2B Source</title>
			</Helmet>
			<CallLogsTable
				params={params}
				setParams={setParams}
				subjectType="trip_sources"
				subjectId={tripSource.id}
				pagination={true}
			/>
		</>
	)
}
